// @flow

import type { BreadcrumbType } from '../../../../common/types/breadcrumb/breadcrumb';

export default function map(responseApiSearchAdsBreadcrumb: ?Array<Object>): BreadcrumbType {
  if (!responseApiSearchAdsBreadcrumb) {
    return [];
  }

  return responseApiSearchAdsBreadcrumb.map(searchAdsBreadcrumbItem => {
    const breadcrumbItemMapped = {
      text: searchAdsBreadcrumbItem.text,
      type: searchAdsBreadcrumbItem.type,
      path: searchAdsBreadcrumbItem.url,
      route: searchAdsBreadcrumbItem.url,
      params: searchAdsBreadcrumbItem.params,
    };

    return breadcrumbItemMapped;
  });
}



// WEBPACK FOOTER //
// ./app/Serp/mappers/apiSearchResponse/common/breadcrumbMapper.js